<div class="logout"><a href="javascript:" (click)="logout()">Logout</a></div>
